import { ImageConverterMixin } from "../../mixins/imageConverter";

export const CategorySecondImageMethods = {
	mixins: [ImageConverterMixin],
	methods: {
		replaceImage(url = "", ref = "lazyImg") {
			if (
				url.length > 0 &&
				App.Eros.Config.itemlists.enableSecondaryImageOnHover &&
				document.body.classList.contains("no-touch")
			) {
				this.$refs[ref][(ref === "lazyImg" ? "srcset" : "src")] = this.convertFormat(url);
			}
		}
	}
};
